import { SystemField } from "./system-field";

export class StaffEndDay extends SystemField{
     
     end_date?:string;
     end_by_id?:string;
     approved_by_id?:string;
}
